import SessionEventProto from "../session-event-proto"
import Resource from "../../model2/resource/resource"
import {EVENT_BUS_SESSION_RESOURCES_CHANGED} from "./@const"


export default class SessionEvent_ResourceReset extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        const models = _.map(this.data, (record: JSONObject) => new Resource(record))
        gd.session.resources.reset(models)
        gd.bus.triggerEvent(EVENT_BUS_SESSION_RESOURCES_CHANGED)
    }
}
